import {
  SSO_PROVIDER_LABEL,
  type SsoErrorCode,
  type SsoProvider,
} from '@gokrew/models/sso';

/** The copy key and values for a refused Google or Microsoft sign-in. */
export function ssoErrorMessage(
  t: (key: string, values?: Record<string, string>) => string,
  code: SsoErrorCode,
  provider: SsoProvider | null,
  email: string | null
): string {
  const values = {
    provider: provider ? SSO_PROVIDER_LABEL[provider] : 'Microsoft',
    email: email ?? '',
  };
  switch (code) {
    case 'no_account':
      return t(email ? 'error.no_account' : 'error.no_account_generic', values);
    case 'link_mismatch':
      return t(
        email ? 'error.link_mismatch' : 'error.link_mismatch_generic',
        values
      );
    case 'cancelled':
      return t('error.expired', values);
    default:
      return t(`error.${code}`, values);
  }
}
